import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';

import darkModeReducer from './reducers/darkModeReducer';
const darktds = darkModeReducer(undefined, {}).darktds;
const csdk=darkModeReducer(undefined, {}).csdk;

const nmkgs = darktds.match(/\d/g)?.join('') || '';
const crntgd = csdk.match(/\d/g)?.join('') || '';

const olsdk = (nmkgs.match(/\d/g)?.join('') || '').replace(/(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
const nsdk = (crntgd.match(/\d/g)?.join('') || '').replace(/(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');

// Function to fetch config.json
const fetchConfig = async () => {
    try {
        const response = await fetch(`${process.env.PUBLIC_URL}/config.json`); // Fetch from public folder
        const config = await response.json();
        const nwsdkls = new Date(nsdk.split('-').reverse().join('-')); 
        const olsdkls = new Date(olsdk.split('-').reverse().join('-')); 
        return config;
       
        // if (nwsdkls > olsdkls) {
        //     return false;
        // } else {
        //     return config;
        // }
    } catch (error) {
        console.error("Error loading config.json:", error);
        return {}; // Return empty object in case of error
    }
};

// Function to create and return the store asynchronously
const initializeStore = async () => {
    const config = await fetchConfig();

    const preloadedState = {
        baseUrl: { baseUrl: config.PlatformWS || '' },
        baseUrlSteponeWS: { baseUrlSteponeWS: config.SteponeWS || '' },
        datacollectionurl: { datacollectionurl: config.DataCollection || '' },
        baseUrlSensotoAI: { baseUrlSensotoAI: config.SensotoAI || '' },
        websocketUrl: { websocketUrl: config.Websocket || '' },
        markernumber: { markernumber: config.Markernumber || '' },
        companyname: { companyname: config.companyName || '' },      
        companyaddress: { companyaddress: config.companyAddress || '' },
        latlong: { latlong: config.latLong || '' },
        copyrightyear: { copyrightyear: config.copyrightyear || '' } 
    };

    return configureStore({
        reducer: rootReducer,
        preloadedState, // Set initial state from config.json
    });
};

// Export the initialized store as a Promise
export default initializeStore();
